import { makeAutoObservable } from 'mobx';
import { User } from '../models/User';
import { TokenStore } from './TokenStore';

export class UserStore {
  _user: User = null;
  _isAuthenticated: boolean = false;

  constructor() {
    makeAutoObservable(this);

    if (TokenStore.instance().hasToken) {
      this._isAuthenticated = true;
    }
  }

  get isAuthenticated(): boolean {
    return this._isAuthenticated;
  }

  set isAuthenticated(isAuthenticated: boolean) {
    this._isAuthenticated = isAuthenticated;
  }

  set token(token: string) {
    if (token == null) {
      TokenStore.instance().reset();
    } else {
      TokenStore.instance().setToken(token);
    }
  }
  
  set user(user: User) {
    this._user = user;
  }

  get user(): User {
    return this._user;
  }

  get userId(): number {
    return parseInt(TokenStore.instance().tokenData.sub);
  }
}
